var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { DrawerHeaderElement } from './DrawerHeader.style';
var DrawerHeader = function (_a) {
    var children = _a.children, onClose = _a.onClose, rounded = _a.rounded, props = __rest(_a, ["children", "onClose", "rounded"]);
    var childrenLength = React.Children.toArray(children).length;
    return (React.createElement(DrawerHeaderElement, __assign({ style: {
            justifyContent: childrenLength === 1 ? 'flex-end' : 'space-between',
        }, rounded: rounded }, props), React.Children.map(children, function (child) {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { onClose: onClose });
        }
        return child;
    })));
};
export { DrawerHeader };
//# sourceMappingURL=DrawerHeader.js.map